import classNames from 'classnames';
import sortBy from 'lodash/sortBy';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import { useFloatingVideo } from '../../contexts/VideoContext';
import Blocks from '../blocks/Blocks';
// import useScrollToTop from '../../hooks/useScrollToTop';
// import Background from '../partials/SectionPageBackground';
import ContactBlock from '../partials/ContactBlock';

import styles from '../../../styles/pages/contact.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    site: AppPropTypes.site.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ContactPage = ({ page, site, className }) => {
    const { blocks = null, contactBlocks = null } = page || {};
    const { setFloatingVideo } = useFloatingVideo();
    const { handle: siteHandle = null } = site || {};

    useEffect(() => {
        setFloatingVideo(null);
    }, [setFloatingVideo]);

    const finalContactBlocks = useMemo(() => {
        if (siteHandle !== null) {
            return sortBy(contactBlocks, (contactBlock) => {
                const { address = null } = contactBlock || {};
                const { name = null } = address || {};
                return name !== null && name.toLowerCase().indexOf(siteHandle) !== -1 ? -1 : 0;
            });
        }
        return contactBlocks;
    }, [siteHandle, contactBlocks]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {/* <Background className={styles.header} pageHandle="media" /> */}
            {blocks !== null ? (
                <Blocks className={styles.blocks} blocks={blocks} isContainer firstInPage />
            ) : null}
            {(finalContactBlocks || []).map((block, idx) => (
                <ContactBlock
                    key={`contact-block-${idx + 1}`}
                    className={styles.contactBlock}
                    contact={block}
                    index={idx}
                    invertLinks={siteHandle === 'france' && idx > 1}
                />
            ))}
        </div>
    );
};

ContactPage.propTypes = propTypes;
ContactPage.defaultProps = defaultProps;

export default ContactPage;
